import { z } from 'zod';

/** Paginação regressiva por seq: a tela abre no fim e pede o que veio antes. */
export const PaginarPorSeqSchema = z.object({
  antesDe: z.coerce.number().int().positive().optional(),
  limite: z.coerce.number().int().min(1).max(500).default(200),
});
export type PaginarPorSeq = z.infer<typeof PaginarPorSeqSchema>;

export const PaginarSchema = z.object({
  pagina: z.coerce.number().int().min(1).default(1),
  porPagina: z.coerce.number().int().min(1).max(100).default(20),
});
export type Paginar = z.infer<typeof PaginarSchema>;
